import { useCallback } from 'react'

import { useAnalyticsContext } from '@b-stock/fe-core/bstock-react'

import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

export type TrackToastView = (
  toastType: 'Success' | 'Failure' | 'Partial_Failure',
  toastMessage: string,
  options?: { bid_ids?: string[]; quick_bid_button_number?: number }
) => void

export const useTrackToastView = (): TrackToastView => {
  const { track } = useAnalytics()
  const { screenName } = useAnalyticsContext()

  return useCallback(
    (toastType, toastMessage, options) => {
      try {
        track('Toast_View', {
          screenName,
          toast_type: toastType,
          toast_message: toastMessage,
          ...(options?.bid_ids !== undefined && { bid_ids: options.bid_ids }),
          ...(options?.quick_bid_button_number !== undefined && {
            quick_bid_button_number: options.quick_bid_button_number,
          }),
        })
      } catch (error) {
        console.error('Failed to track Toast_View', error)
      }
    },
    [track, screenName]
  )
}
